import { LanguageUtils, SentenceFormatter } from '@pbt/pbt-ui-components'

import type { PreferenceDisplaySubCategoryData } from '~/types'

import styles from './RhapPreferencesDisplayRow.module.scss'

export interface RhapPreferencesDisplayRowProps {
  categoryTitle: string
  subCategory: PreferenceDisplaySubCategoryData[]
}

const RhapPreferencesDisplayRow = ({
  subCategory,
  categoryTitle,
}: RhapPreferencesDisplayRowProps) => (
  <div className={styles.container}>
    <div className={styles.categoryTitle}>
      <span>{categoryTitle}</span>
    </div>
    <div className={styles.categoryDetails}>
      {subCategory.map(({ subCategoryTitle, subCategoryPreferences }) => {
        const preferenceString = Array.isArray(subCategoryPreferences)
          ? LanguageUtils.getSentence(
              subCategoryPreferences,
              SentenceFormatter.REGULAR,
              ', ',
            )
          : subCategoryPreferences

        return (
          subCategoryPreferences.length > 0 && (
            <div
              className={styles.subCategoryContainer}
              key={`${subCategoryTitle}-${preferenceString}-subcategory-preference`}
            >
              <span className={styles.subCategoryTitle}>
                {`${subCategoryTitle}:`}&nbsp;
              </span>
              <span className={styles.subCategoryDetails}>
                {preferenceString}
              </span>
            </div>
          )
        )
      })}
    </div>
  </div>
)

export default RhapPreferencesDisplayRow
